(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  const heroBannerFadeMs = 850;
  const heroBannerHoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

  function heroBannerSlides(root) {
    return Array.from(root.querySelectorAll(':scope .hero-banner__slide'));
  }

  function heroBannerSetActive(root, index, { immediate = false } = {}) {
    const slides = heroBannerSlides(root);
    if (!slides.length) return;

    const next = ((index % slides.length) + slides.length) % slides.length;
    const current = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (next === current) return;
    if (!immediate && root.dataset.animating === 'true') return;

    if (!immediate) root.dataset.animating = 'true';

    slides.forEach((slide, i) => {
      const active = i === next;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      slide.querySelectorAll('a, button').forEach((element) => {
        if (active) {
          element.removeAttribute('tabindex');
        } else {
          element.setAttribute('tabindex', '-1');
        }
      });
    });

    window.setTimeout(() => {
      root.dataset.animating = 'false';
    }, immediate ? 0 : heroBannerFadeMs);
  }

  function heroBannerStopAutoplay(root) {
    if (root._heroAutoplay) {
      window.clearTimeout(root._heroAutoplay);
      root._heroAutoplay = null;
    }
  }

  function heroBannerStartAutoplay(root) {
    heroBannerStopAutoplay(root);
    if (root.getAttribute('data-autoplay') !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (document.hidden) return;

    const speed = Number(root.getAttribute('data-speed') || 5) * 1000;
    root._heroAutoplay = window.setTimeout(() => {
      root._heroAutoplay = null;
      if (root.dataset.animating === 'true') {
        heroBannerStartAutoplay(root);
        return;
      }

      const slides = heroBannerSlides(root);
      const current = Math.max(
        0,
        slides.findIndex((slide) => slide.classList.contains('is-active'))
      );
      heroBannerSetActive(root, current + 1);
      heroBannerStartAutoplay(root);
    }, speed);
  }

  function heroBannerInit(root) {
    const slides = heroBannerSlides(root);
    slides.forEach((slide, i) => {
      if (i !== 0 && !slide.classList.contains('is-active')) {
        slide.querySelectorAll('a, button').forEach((element) => {
          element.setAttribute('tabindex', '-1');
        });
      }
    });

    if (root.dataset.heroReady === 'true') {
      heroBannerStartAutoplay(root);
      return;
    }

    root.dataset.heroReady = 'true';
    root.addEventListener('mouseenter', () => {
      if (!heroBannerHoverQuery.matches) return;
      heroBannerStopAutoplay(root);
    });
    root.addEventListener('mouseleave', () => {
      if (!heroBannerHoverQuery.matches) return;
      heroBannerStartAutoplay(root);
    });
    heroBannerStartAutoplay(root);
  }

  function heroBannerInitAll() {
    document.querySelectorAll('[data-hero-slideshow]').forEach(heroBannerInit);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-hero-nav]');
    if (!button) return;

    const root = button.closest('[data-hero-slideshow]');
    if (!root) return;

    event.preventDefault();
    const slides = heroBannerSlides(root);
    const current = Math.max(
      0,
      slides.findIndex((slide) => slide.classList.contains('is-active'))
    );
    const delta = button.getAttribute('data-hero-nav') === 'next' ? 1 : -1;
    heroBannerSetActive(root, current + delta);
    heroBannerStartAutoplay(root);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', heroBannerInitAll);
  } else {
    heroBannerInitAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-hero-slideshow]').forEach(heroBannerInit);
  });

  document.addEventListener('visibilitychange', () => {
    document.querySelectorAll('[data-hero-slideshow]').forEach((root) => {
      if (document.hidden) {
        heroBannerStopAutoplay(root);
      } else {
        heroBannerStartAutoplay(root);
      }
    });
  });

  document.addEventListener('shopify:block:select', (event) => {
    if (!event.target.classList.contains('hero-banner__slide')) return;
    const root = event.target.closest('[data-hero-slideshow]');
    if (!root) return;
    heroBannerStopAutoplay(root);
    root.dataset.animating = 'false';
    heroBannerSetActive(root, heroBannerSlides(root).indexOf(event.target), { immediate: true });
  });

  } catch(e) { console.error(e); }
})();
})();
